import { render, staticRenderFns } from "./unionRoleEdit.vue?vue&type=template&id=da9dfd62&scoped=true&"
import script from "./unionRoleEdit.vue?vue&type=script&lang=js&"
export * from "./unionRoleEdit.vue?vue&type=script&lang=js&"
import style0 from "./unionRoleEdit.vue?vue&type=style&index=0&id=da9dfd62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9dfd62",
  null
  
)

component.options.__file = "unionRoleEdit.vue"
export default component.exports